<div class="modal-container-custom">
  <div class="modal-content-custom simpleStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="sign-documents-close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Send Docs for Signing</h4>
    </div>
    <div class="modal-body">
      <form autocomplete="off" [formGroup]="signDocumentsForm">
        <div formArrayName="sign_documents"
          *ngFor="let document of signDocumentsForm.get('sign_documents')['controls']; let docIndex = index; last as isLast;">
          <div [formGroupName]="docIndex">
            <h6 class="text-center py-2">{{documentNamesMap[document.value.document_name]}}</h6>
            <div class="dark-section mb-6">
              <ng-select [attr.id]="document.value.document_name" [items]="modalInputs.signatoriesList"
                class="icici-custom" [multiple]="true" bindLabel="name" bindValue="id" [hideSelected]="true"
                notFoundText="Could not find the specified signatory." formControlName="selectedSignatories"
                *ngIf="document.value.signing_option === onlyEsign" placeholder="Search for Signatories ... ">
                <!--Template for selected label-->
                <ng-template ng-label-tmp let-signatory="item">
                  <span class="ng-value-label">{{signatory.name}}
                    <small *ngIf="signatory.group_name" class="info-text font-style-normal">
                      ({{signatory.group_name}})</small>
                  </span>
                  <span aria-hidden="true" class="ng-value-icon right"
                    (click)="removeDocSignatory(docIndex, signatory.id)">×</span>
                </ng-template>
                <!--Template for option in select dropdown-->
                <ng-template ng-option-tmp let-signatory="item">
                  {{signatory.name}}
                  <small *ngIf="signatory.group_name" class="info-text font-style-normal">
                    ({{signatory.group_name}})</small>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer modal-footer-custom simpleStyle_2">
        <button type="button" class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
          id="sign-documents-cancel" (click)="activeModal.close()">Cancel</button>
        <button class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
          id="sign-documents-submit" (click)='postSignedDocuments()'>Done</button>
      </div>
    </div>
  </div>
</div>